import { Dialog } from '@headlessui/react'

type ConfirmModalProps = {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void,
  content: JSX.Element
}

const ConfirmModal = ({ open, onClose, onConfirm, content }: ConfirmModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} className="z-50 absolute top-9 left-0 w-full h-full bg-gray-100 bg-opacity-80 flex items-center justify-center">
      <Dialog.Panel className="w-[340px] -mt-9 flex flex-col items-center justify-center gap-2 border border-gray-400 rounded-lg bg-gray-200 py-4">
        {content}
        <div className="flex gap-10">
          <div className="w-20 h-8 border border-gray-300 rounded flex items-center justify-center text-gray-500 cursor-pointer" onClick={onClose}>Cancel</div>
          <div className="w-20 h-8 bg-red-main rounded flex items-center justify-center text-white cursor-pointer" onClick={onConfirm}>Confirm</div>
        </div>
      </Dialog.Panel>
    </Dialog>
  )
}

export default ConfirmModal